import { scoreRGB } from "@lib/helper/scoreUtils";
import { reliabilityImages } from "@lib/images";
import { SourceReliability } from "@lib/store/models/brandsModels";

const _sourceColorMap: { [name: string]: string } = {
  [SourceReliability.reliable]: scoreRGB.highest,
  [SourceReliability.accepted]: scoreRGB.high,
  [SourceReliability.warning]: scoreRGB.medium,
  [SourceReliability.waiting]: scoreRGB.low,
};

export const selectSourceColor = (reliability: SourceReliability): string => {
  return _sourceColorMap[reliability] || scoreRGB.medium;
};

const _sourceTextMap: { [name: string]: string } = {
  [SourceReliability.reliable]: "reliabilitySource.reliable",
  [SourceReliability.accepted]: "reliabilitySource.accepted",
  [SourceReliability.warning]: "reliabilitySource.warning",
  [SourceReliability.waiting]: "reliabilitySource.waiting",
};

export const selectSourceText = (reliability: SourceReliability): string => {
  return _sourceTextMap[reliability] || "reliabilitySource.warning";
};

// ReliabilitySources
const reliabilitySourcesMap: { [name: string]: string } = {
  reliable: reliabilityImages.reliable,
  accepted: reliabilityImages.reliable,
  warning: reliabilityImages.warning,
  waiting: reliabilityImages.waiting,
};

export function selectImgReliabilitySources(reliability: SourceReliability): string {
  return reliabilitySourcesMap[reliability] || reliabilityImages.warning;
}
